import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommandListPageData,
  getCommandListPageDataSuccess,
} from "../../store/command-list-page.store";
import CommandListView from "../../views/mobile-frame/command-list/CommandListView";
import { Box, makeStyles } from "@material-ui/core";
import PullToRefresh from "react-simple-pull-to-refresh";

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
}));

const CommandListContainer = ({ type, eklok }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { token } = useContext(AuthContext);

  const { dataFetched, error, loading } = useSelector((state) => {
    return state.commandListPage;
  });

  const { eklokData, commandList } = useSelector((state) => {
    return state.manualCommandList;
  });

  console.log("commandList", commandList);

  const onRefresh = () =>
    new Promise((resolve, reject) => {
      dispatch(
        getCommandListPageData({
          token: token,
          eklok: eklok,
        }),
      );
      resolve();
    });

  useEffect(() => {
    if (!eklokData || eklokData.id !== eklok || commandList.all === null) {
      dispatch(
        getCommandListPageData({
          token: token,
          eklok: eklok,
        }),
      );
    } else {
      dispatch(getCommandListPageDataSuccess());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PullToRefresh onRefresh={onRefresh} pullingContent={false}>
      {loading ? <Loading /> : null}
      <Box className={classes.container}>
        {error ? <Error message={{ message: error.message }} /> : null}
        {dataFetched ? (
          <CommandListView
            type={type}
            commands={commandList[type]}
            eklokData={eklokData}
          />
        ) : null}
      </Box>
    </PullToRefresh>
  );
};

export default CommandListContainer;
